import { CUSTOM_ELEMENTS_SCHEMA, NgModule, provideZonelessChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from '@core/interceptors/token.interceptor';
import { HeaderComponent } from './core/components/header/header.component';
import { HomeLandingPageComponent } from '@pages/home/home-landing-page/home-landing-page.component';
import { LoaderInterceptor } from './core/interceptors/loader.interceptor';
import { DynamicScriptDirective } from './core/directives/dynamic-script.directive';
import { MAT_DATE_LOCALE } from '@angular/material/core';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    HeaderComponent,
    HomeLandingPageComponent,
    DynamicScriptDirective
  ],
  providers: [
    provideZonelessChangeDetection(),
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
